import React from 'react';
import ZoomDefault, { Controlled } from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';

const Zoom = ({ children, ...restProps }) => {
  return <ZoomDefault {...restProps}>{children}</ZoomDefault>;
};

export const ZoomControlled = Controlled;

export default Zoom;
